import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { observeAdminAccess } from "../lib/auth";

import logoMedium from '../assets/SYM_email_banner_speechBubble.svg';
function Nav() {
  const location = useLocation();
  // const navigate = useNavigate(); // reserved for future route pushes
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => observeAdminAccess((adminAccess) => {
    setIsAdmin(Boolean(adminAccess?.isAdmin));
  }), []);
  const isHomepage = location.pathname === "/";

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1200px)");

    const handleDesktopChange = (event) => {
      if (event.matches) {
        setIsMenuOpen(false);
      }
    };

    handleDesktopChange(mediaQuery);

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handleDesktopChange);
      return () => mediaQuery.removeEventListener("change", handleDesktopChange);
    }

    mediaQuery.addListener(handleDesktopChange);
    return () => mediaQuery.removeListener(handleDesktopChange);
  }, []);

  useEffect(() => {
    if (!isHomepage) {
      setIsScrolled(false);
      return undefined;
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 8);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomepage]);

  return (
    <nav
      className={`navbar navbar-expand-xl navbar-light py-3 sym-navbar${isHomepage ? " sym-navbar-home" : ""}${isScrolled ? " sym-navbar-scrolled" : ""}`}
      aria-label="Primary"
    >
      <div className="container-fluid sym-navbar-inner">
        <Link
          to="/"
          className="navbar-brand brand-wrapper me-3"
        >
          <img className="brand-logo" src={logoMedium} alt="Speak Your Menu" />
          <span className="brand-tagline">Menu Training App</span>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="nav_lc"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`navbar-collapse collapse${isMenuOpen ? " show" : ""}`} id="nav_lc">
          <ul className="navbar-nav my-3 my-lg-0 ms-lg-3 me-auto">
            <li className="nav-item me-4">
              <Link
                to="/"
                className={`nav-link fw-semibold px-2${location.pathname === "/" ? " active" : ""}`}
                aria-current={location.pathname === "/" ? "page" : undefined}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
            </li>
            <li className="nav-item me-4">
              <Link
                to="/features"
                className={`nav-link fw-semibold px-2${location.pathname === "/features" ? " active" : ""}`}
                aria-current={location.pathname === "/features" ? "page" : undefined}
                onClick={() => setIsMenuOpen(false)}
              >
                Features
              </Link>
            </li>
            <li className="nav-item me-4">
              <Link
                to="/pricing"
                className={`nav-link fw-semibold px-2${location.pathname === "/pricing" ? " active" : ""}`}
                aria-current={location.pathname === "/pricing" ? "page" : undefined}
                onClick={() => setIsMenuOpen(false)}
              >
                Pricing
              </Link>
            </li>
            <li className="nav-item me-4">
              <Link
                to="/about"
                className={`nav-link fw-semibold px-2${location.pathname === "/about" ? " active" : ""}`}
                aria-current={location.pathname === "/about" ? "page" : undefined}
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
            </li>
            <li className="nav-item me-4">
              <Link
                to="/contact"
                className={`nav-link fw-semibold px-2${location.pathname === "/contact" ? " active" : ""}`}
                aria-current={location.pathname === "/contact" ? "page" : undefined}
                onClick={() => setIsMenuOpen(false)}
              >
                Contact Us
              </Link>
            </li>
            <li className="nav-item me-4">
              <Link
                to="/faq"
                className={`nav-link fw-semibold px-2${location.pathname === "/faq" ? " active" : ""}`}
                aria-current={location.pathname === "/faq" ? "page" : undefined}
                onClick={() => setIsMenuOpen(false)}
              >
                FAQ
              </Link>
            </li>
            <li className="nav-item me-4">
              <Link
                to="/blog"
                className={`nav-link fw-semibold px-2${location.pathname.startsWith("/blog") ? " active" : ""}`}
                aria-current={location.pathname.startsWith("/blog") ? "page" : undefined}
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
            </li>
            {isAdmin && (
              <>
                <li className="nav-item me-4">
                  <Link
                    to="/Char3tt34su"
                    className={`nav-link fw-semibold px-2${location.pathname === "/Char3tt34su" ? " active" : ""}`}
                    aria-current={location.pathname === "/Char3tt34su" ? "page" : undefined}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Admin
                  </Link>
                </li>
              </>
            )}
          </ul>
          <div className="d-flex align-items-center">
            <a
              href="https://app.speakyourmenu.com/login"
              className="btn sym-navbar-signin fw-semibold me-2"
              rel="noopener noreferrer"
            >
              Sign in
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
